import React from 'react'

const Logo = props => (
    <div className={`brand-logo__container ${props.className || ''}`}>
        {props.imgSrc && <img src={props.imgSrc} className="logo_img" alt="logo" />}
    </div>
)

export default Logo
